module.exports = __webpack_public_path__ + "static/media/clinic-logo.ad4f9e2d.svg";